import { render } from "./UserLayout.vue?vue&type=template&id=7b1b5fa0&scoped=true"
import script from "./UserLayout.vue?vue&type=script&lang=js"
export * from "./UserLayout.vue?vue&type=script&lang=js"

import "./UserLayout.vue?vue&type=style&index=0&id=7b1b5fa0&lang=less&scoped=true"

import exportComponent from "/Volumes/my/猫嗅笔记相关项目/猫嗅笔记管理后台/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1b5fa0"]])

export default __exports__